import React from 'react';

export default function CheckElement() {
  return (
    <svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.95837 11L0.208374 6.25002L1.39587 5.06252L4.95837 8.62502L12.6042 0.979187L13.7917 2.16669L4.95837 11Z"
        fill="#1C1B1F"
      />
    </svg>
  );
}
